// Lib
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { isRealUserId } from '../../../../../../common/users/userHelper';

// Selectors
import { getCurrentUserId } from '../../../../../user/currentUserSelector';

// Actions
import { fetchNavigationHistory } from '../../../../../user/navigationHistory/navigationHistoryActions';

/**
 * Fetches the navigation history on mount.
 */
const useFetchHistoryOnMount = () => {
    const dispatch = useDispatch();

    const currentUserId = useSelector(getCurrentUserId);

    const dispatchFetchHistory = useCallback(() => dispatch(fetchNavigationHistory()), []);

    useEffect(() => {
        if (!currentUserId) return;

        if (!isRealUserId(currentUserId)) return;

        dispatchFetchHistory();
    }, [currentUserId]);
};

export default useFetchHistoryOnMount;
